import { Injectable, HostListener } from '@angular/core';
import {HttpClient,HttpParams,HttpHeaders} from "@angular/common/http";
import { from, Observable } from 'rxjs';


import { FormGroup } from '@angular/forms';

import { retry, catchError } from 'rxjs/operators';
import { GlobalService } from 'src/app/global.service';



@Injectable({providedIn:"root"})
export class ListingService {
  

  constructor(private http:HttpClient,private global:GlobalService) {

   }
public getQuoteListService(data:any){
    // alert("service"+this.global.Baseurl);
   return this.http.post(this.global.Baseurl+this.global.quoteListRouting,data);
 }
  
public getModelLovService(data:any){
   // alert("service"+this.global.Baseurl);
  return this.http.get(this.global.Baseurl+this.global.getmodellovrouting+""+data);
}
  
public getFilterListingService(obj){
  // alert("service"+this.global.Baseurl);
 return this.http.post(this.global.Baseurl+this.global.getFilterListingWS,obj);
}
  
public getListingService(obj){
  // alert("service"+this.global.Baseurl);
 return this.http.post(this.global.Baseurl+this.global.getListingWS,obj);
}
public preauthrequestlisting(obj){
  // alert("service"+this.global.Baseurl);
 return this.http.post(this.global.bohminhURL+this.global.preauthrequestlisting,obj);
}
public claimintrequestlisting(obj){
  // alert("service"+this.global.Baseurl);
 return this.http.post(this.global.bohminhURL+this.global.claimintrequestlisting,obj);
}

 

public getProposalListService(obj){
  return this.http.post(this.global.Baseurl+this.global.getProposalListingRouting,obj);
}
public getPaymentOfMode(P_MODE_PAY){
  return this.http.get(this.global.BaseMedicalurl+this.global.getModeOfPayments,P_MODE_PAY);
}
public getDepositAmount(P_MODE_PAY){
  return this.http.get(this.global.BaseMedicalurl+this.global.getdepositAmount,P_MODE_PAY);
}
  
public getListingLOVs(value:string){
  console.log("Full URL: ", this.global.Baseurl+this.global.getPageLOVs+value)
  return this.http.get(this.global.Baseurl+this.global.getPageLOVs+value);
}
public getTypeData(){
  return this.http.get(this.global.BaseMedicalurl+this.global.typeUrl);
}
public getClaimSearchList(obj){
  return this.http.post(this.global.Baseurl+this.global.getClaimSearchListWS,obj);
}
public downloadlist(agentname){

  return this.http.get(this.global.Baseurl+this.global.getUploadedFiles+agentname);

}
getPolicyNumbers(code) : Observable<any>{
  return this.http.get<any>(this.global.Baseurl + this.global.getPolicyNumbers+code)
}

getPolDetails(polNo) : Observable<any>{
  let obj = {
    "polNo": polNo
  }
  return this.http.post<any>(this.global.Baseurl + this.global.getIntimationPolicyDetails, obj)
}

//For dashboard filter search click

public getFilterdashboardService(obj){

 return this.http.post(this.global.Baseurl+this.global.getPolicyChartRouting,obj);
}
public installbreakup(quoteNo){
  
  return this.http.get(this.global.Baseurl+this.global.installmentrouting+"?quoteNo="+quoteNo);
}

public getLockQuoteDetails(quoteNo,userName){
  
  return this.http.get(this.global.Baseurl+this.global.LockQuoteDetails+"?quoteNo="+quoteNo+"&&userName="+userName);
}

public unlockQuotedetails(userName){

return this.http.get(this.global.Baseurl+this.global.unlockQuote+"?userName="+userName);

}
//for drill down feature
public getpolicyDetails(obj){

 return this.http.post(this.global.Baseurl+this.global.getpolicyDetailsWS,obj);
}
//CSR Drill down feature
public getcsrpolicyDetails(obj){
  
  return this.http.post(this.global.Baseurl+this.global.getcsrpolicyDetails,obj);

}
public getapprovalmatrixdetail(quoteNo){
  
  return this.http.get(this.global.Baseurl+this.global.approvalmatrixDetails+"?quoteNo="+quoteNo); 
}
public gettransactiondetails(quoteNo){
  
  return this.http.get(this.global.Baseurl+this.global.transactionDetails+"?quoteNo="+quoteNo);
}

public getheaderdetails(quoteNo){
  
  return this.http.get(this.global.Baseurl+this.global.getheaderdetails+"?quoteNo="+quoteNo); 
}

public getPolicydetails(RHsysid){
  
  return this.http.get(this.global.Baseurl+this.global.policyDetails+"?RHsysid="+RHsysid);
}

//standlone receipting

public getstdPolicydetails(RHsysid){
  
  return this.http.get(this.global.Baseurl+this.global.getstdPolicydetails+"?RHsysid="+RHsysid);
}

public insertpaymentDetails(obj){
  
  return this.http.post(this.global.Baseurl+this.global.insertpaymentDetails,obj);
}

public getreceiptdetails(RHsysid){
  
  return this.http.get(this.global.Baseurl+this.global.receiptDetails+"?RHsysid="+RHsysid);
}

public insertExcecssDetails(obj){
  
  return this.http.post(this.global.Baseurl+this.global.insertExcecssDetails,obj);
}
public updatePolicyDetails(obj1){
  
  return this.http.post(this.global.Baseurl+this.global.updatePolicyDetails,obj1);
}

public updateStandPolicyDetails(data:any){
  
  return this.http.post(this.global.Baseurl+this.global.updateStandPolicyDetails,data);
}

public getReceiptlisting(){
  
  return this.http.get(this.global.Baseurl+this.global.getReceiptlisting);
 
}
public getdata(quoteNo){
  
  return this.http.get(this.global.Baseurl+this.global.getdata+"?quoteNo="+quoteNo);
}

public insertpaymentDetailsAdv(obj){
  
  return this.http.post(this.global.Baseurl+this.global.insertpaymentDetailsAdv,obj);
}



public generateReceipt(obj){
  
  return this.http.post(this.global.Baseurl+this.global.generateReceipt,obj);
}

public getAdvReceiptlisting(){
  
  return this.http.get(this.global.Baseurl+this.global.getAdvReceiptlisting);
}

public receiptdtlsSave(obj){
  
  return this.http.post(this.global.Baseurl+this.global.receiptdtlsSave,obj); 
}


public preauthlistingView(obj){
  // alert("service"+this.global.Baseurl);
 return this.http.post(this.global.bohminhURL+this.global.preauthlistingView,obj);
}

public claimIntlistingView(obj){
  // alert("service"+this.global.Baseurl);
 return this.http.post(this.global.bohminhURL+this.global.claimIntlistingView,obj);
}

public preauthrequestReport(obj){
 // alert("service"+this.global.Baseurl);
 return this.http.post(this.global.Baseurl+this.global.preAuthRequestReport,obj);
}
}
